import React from 'react'
import styles from "./SpotLoader.module.css"

export default function SpotLoader({...rest}) {
  return <div {...rest}>
    <svg version="1.1" x="0" y="0" width="100%" height="100%" viewBox="-10 -10 120 120" enableBackground="new 0 0 200 200" className={styles.svg}>
      <path
        className={styles.circle}
        d="M0,50 A50,50,0 1 1 100,50 A50,50,0 1 1 0,50"
      />
    </svg>
  </div>
}
